'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var links = context.getElements('a');

  links.forEach(function (link) {
    var linkText = link.textContent;
    link.setAttribute('data-text', linkText);
  });
}